export function getComputerModeMenuDisplayName() {
    return 'ComputerModeMenuItems';
}
//# sourceMappingURL=chunkAnchor.js.map